import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import { DeleteFilled, EditFilled } from "@ant-design/icons";
import {
  adjustmentBulkDisable,
  adjustmentBulkEnable,
  deleteDeltaHedgeExeTask,
  deltaHedgeBulkDisable,
  deltaHedgeBulkEnable,
  bulkSetAdjusmentToOffset,
  bulkSetAdjusmentToOpenPortfo,
  bulkSetAdjusmentToOpen,
} from "../../../Requests/deltaHedgeExe";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import AddEditTask from "../../../Pages/DeltaHedgeExePhase3/ExeManagement/AddEditTask";
import { IDeltaHedgeExeManagementTableReport } from "../../../Interfaces/deltaHedgeExe";
import DeltaHedgeExeTaskLogsTable from "./DeltaHedgeExeTaskLogsTable";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";

enum Action {
  EnableDeltaHedge,
  DisableDeltaHedge,
  EnableAdjustment,
  DisableAdjustment,
  None,
}

enum AdjustmentAction {
  OffsetPlusAll,
  OffsetPlusProperty,
  Offset,
  None,
}

const AdditionalHeader = ({
  isSelectAll,
  onAction,
  selectedRowsIds,
  setSelectedRowsIds,
}: IAdditionalHeaderProps) => {
  const [selectedAction, setSelectedAction] = useState<Action>(Action.None);
  const [selectedAdjustmentAction, setSelectedAdjustmentAction] =
    useState<AdjustmentAction>(AdjustmentAction.None);
  const [loading, setLoading] = useState(false);

  const getBulkActionFunction = () => {
    switch (selectedAction) {
      case Action.DisableAdjustment:
        return adjustmentBulkDisable;
      case Action.EnableAdjustment:
        return adjustmentBulkEnable;
      case Action.DisableDeltaHedge:
        return deltaHedgeBulkDisable;
      case Action.EnableDeltaHedge:
        return deltaHedgeBulkEnable;
      default:
        return null;
    }
  };
  const getBulkAdjustmentActionFunction = () => {
    switch (selectedAdjustmentAction) {
      case AdjustmentAction.Offset:
        return bulkSetAdjusmentToOffset;
      case AdjustmentAction.OffsetPlusProperty:
        return bulkSetAdjusmentToOpenPortfo;
      case AdjustmentAction.OffsetPlusAll:
        return bulkSetAdjusmentToOpen;

      default:
        return null;
    }
  };

  const bulkActionsHandler = () => {
    if (selectedAction === Action.None) return;
    if (!selectedRowsIds || !selectedRowsIds.length) return;
    const actionFunction = getBulkActionFunction();
    if (!actionFunction) return;
    setLoading(true);
    actionFunction(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };
  const bulkAdjustmentActionsHandler = () => {
    if (selectedAdjustmentAction === AdjustmentAction.None) return;
    if (!selectedRowsIds || !selectedRowsIds.length) return;
    const actionFunction = getBulkAdjustmentActionFunction();
    if (!actionFunction) return;
    setLoading(true);
    actionFunction(selectedRowsIds)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const actionOptions: DropdownItem[] = [
    { id: Action.DisableDeltaHedge, name: "خاموش کردن تسک های دلتاهج" },
    { id: Action.EnableDeltaHedge, name: "روشن کردن تسک های دلتاهج" },
    { id: Action.EnableAdjustment, name: "روشن کردن تسک های تعدیل" },
    { id: Action.DisableAdjustment, name: "خاموش کردن تسک های تعدیل" },
  ];
  const actionAdjustmentOptions: DropdownItem[] = [
    { id: AdjustmentAction.OffsetPlusAll, name: "آفستی + ورودی همه" },
    { id: AdjustmentAction.OffsetPlusProperty, name: "آفستی + ورودی دارایی" },
    { id: AdjustmentAction.Offset, name: "آفستی" },
  ];

  return (
    <>
      <TableCell>
        {loading ? <FullScreenLoading /> : <></>}
        <div className="w-[250px] flex gap-3 items-center">
          <StaticDropdown
            dropdown={{
              name: "",
              placeholder: " تعدیل عملیات گروهی",
            }}
            onChange={(_, v) => setSelectedAdjustmentAction(v)}
            options={actionAdjustmentOptions}
            value={selectedAdjustmentAction}
          />
          <div className="min-w-min min-h-min">
            <Button
              text="اعمال"
              onClick={bulkAdjustmentActionsHandler}
              variant="outlined"
              disabled={
                selectedAdjustmentAction === AdjustmentAction.None ||
                !selectedRowsIds ||
                !selectedRowsIds.length
              }
              className="table-btn"
            />
          </div>
        </div>
      </TableCell>
      <TableCell>
        {loading ? <FullScreenLoading /> : <></>}
        <div className="w-[250px]">
          <StaticDropdown
            dropdown={{
              name: "",
              placeholder: "عملیات گروهی",
            }}
            onChange={(_, v) => setSelectedAction(v)}
            options={actionOptions}
            value={selectedAction}
          />
        </div>
      </TableCell>
      <TableCell>
        <Button
          text="اعمال"
          onClick={bulkActionsHandler}
          variant="outlined"
          disabled={
            selectedAction === Action.None ||
            !selectedRowsIds ||
            !selectedRowsIds.length
          }
          className="table-btn"
        />
      </TableCell>
    </>
  );
};

enum ModalMode {
  Edit,
  Logs,
  Closed,
}

const AdditionalCol: React.FC<{
  row: IDeltaHedgeExeManagementTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [loading, setLoading] = useState(false);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Logs:
        return <DeltaHedgeExeTaskLogsTable id={row.id} />;

      case ModalMode.Edit:
        return (
          <AddEditTask
            onSuccess={onAction}
            editValues={{
              accountIds: [row.userId],
              deltaTolerancePercent: row.deltaUnitPercent,
              gammaTolerancePercent: row.gammaUnitPercent,
              groupIds: [row.groupId],
              targetDeltaPercent: row.targetDelta,
              targetGammaPercent: row.targetGamma,
              id: row.id,
              strategyId: row.strategyId?.toString() || "",
              adjustmentType: row.adjustmentType,
            }}
            onClose={() => setModalMode(ModalMode.Closed)}
          />
        );

      case ModalMode.Closed:
        return <></>;
    }
  };

  const deleteHandler = () => {
    setLoading(true);
    deleteDeltaHedgeExeTask(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
          setModalMode(ModalMode.Closed);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <TableCell>
        <div className="flex items-center justify-center">
          {modalMode !== ModalMode.Closed ? (
            <Modal
              UI={getModalUI()}
              onClose={() => setModalMode(ModalMode.Closed)}
            />
          ) : (
            <></>
          )}
          {loading ? <FullScreenLoading /> : <></>}
          <div className="w-16">
            <Button
              text="لاگ"
              variant="contained"
              className="table-btn"
              onClick={() => setModalMode(ModalMode.Logs)}
            />
          </div>
        </div>
      </TableCell>
      <TableCell>
        <div
          className="w-16 mx-auto"
          onClick={() => setModalMode(ModalMode.Edit)}
        >
          <EditFilled />
        </div>
      </TableCell>
      <TableCell>
        <div className="w-16" onClick={deleteHandler}>
          <DeleteFilled />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDeltaHedgeExeManagementTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
